import React from 'react';

import { css } from '@emotion/css';
import { ValidationRuleTemplateCategory } from '@recurrency/core-api-schema/dist/common/enums';
import { theme } from 'theme';

import { Typography } from 'components/Typography';

import { getTemplateCategoryTitle } from './utils';

export const TemplateCategoryRow = ({
  category,
  selectedCategory,
  setSelectedCategory,
}: {
  category: ValidationRuleTemplateCategory;
  selectedCategory: ValidationRuleTemplateCategory;
  setSelectedCategory: (category: ValidationRuleTemplateCategory) => void;
}) => (
  <div
    className={selectedCategory !== category ? defaultStyling : selectedStyling}
    key={category}
    onClick={() => setSelectedCategory(category)}
  >
    <Typography style={{ fontWeight: 500, color: 'inherit' }} type="subtitle">
      {getTemplateCategoryTitle(category)}
    </Typography>
  </div>
);

const defaultStyling = css`
  margin: 0px 16px 10px 16px;
  padding: 10px;
  :hover {
    cursor: pointer;
    background: ${theme.colors.neutral[200]};
    border-radius: 6px;
    color: ${theme.colors.primary[500]};
  }
`;

const selectedStyling = css([
  defaultStyling,
  { color: theme.colors.primary[500], background: theme.colors.primary[200], borderRadius: '6px' },
]);
